import styled from "styled-components";

export const StyledWrapper = styled.div`
  width: 100%;
  padding: 2.375rem 1.875rem 1.625rem 1.875rem;
`;
